import type { ComponentProps } from "react"

export default function IndustryA(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M14.6666 2.66663H17.3333V5.33329H14.6666V2.66663ZM19.7706 6.34396L21.6573 4.45863L23.5426 6.34396L21.656 8.22929L19.7706 6.34396ZM22.6666 10.6666H25.3333V13.3333H22.6666V10.6666ZM8.45863 6.34396L10.344 4.45729L12.2293 6.34396L10.344 8.22929L8.45863 6.34396ZM6.66663 10.6666H9.33329V13.3333H6.66663V10.6666ZM3.99996 16C3.64634 16 3.3072 16.1404 3.05715 16.3905C2.8071 16.6405 2.66663 16.9797 2.66663 17.3333V27.1106L9.33329 16H3.99996ZM17.3333 16L18.6666 29.3333H24L20 16H17.3333ZM28 16H22.6666L29.3333 27.1106V17.3333C29.3333 16.9797 29.1928 16.6405 28.9428 16.3905C28.6927 16.1404 28.3536 16 28 16ZM7.99996 29.3333H13.3333L14.6666 16H12L7.99996 29.3333ZM10.6666 12C10.6715 12.9389 10.927 13.8595 11.4066 14.6666H20.5933C21.073 13.8595 21.3284 12.9389 21.3333 12C21.3333 10.5855 20.7714 9.22892 19.7712 8.22872C18.771 7.22853 17.4144 6.66663 16 6.66663C14.5855 6.66663 13.2289 7.22853 12.2287 8.22872C11.2285 9.22892 10.6666 10.5855 10.6666 12Z"
        fill={fill}
      />
    </svg>
  )
}
